const error_message = {
  EMSG_0001: `Something went wrong. Please try again or contact admin for supports.`,
  EMSG_1001: `This user has already been in another institution.`,
  EMSG_2001: `Institution code has already been used`,
  EMSG_2002: `Please upload a file less than 1.5MB`,
  EMSG_3001: `Role code has already been used`,
  EMSG_3002: `Not found role ID`,
  EMSG_3003: `Cannot delete default roles`,
  EMSG_3004: `Role name has already been used`,
  EMSG_4001: `User name has already been used`,
  EMSG_4002: `Please upload a file less than 1.5MB`,
  EMSG_4003: `Group Account has already been used`,
  EMSG_5001: `Not found study ID`,
  EMSG_5002: `Fail to sync match status to studylist`,
  EMSG_6001: `Procedure group name has already been used`,
  EMSG_6002: `Procedure code has already been used`,
  EMSG_7001: `Template Report Code already been used`,
  EMSG_8001: `Patient ID invalid, please choose the same Patient ID`,
  EMSG_8002: `Order already been used`,
  EMSG_8003: `Not found order ID`,
  EMSG_8004: `Order status is Matched. Please unmatch first.`,
  EMSG_8005: `Fail to match order with study.`,
  EMSG_8006: `Fail to unmatch order with study.`,
  EMSG_8007: `Fail to sync order status.`,
  EMSG_8008: `Visit ID already been used. Please fill a different value or leave it blank`,
  EMSG_8009: `Order ID already been used. Please fill a different value or leave it blank`,
  EMSG_8010: `Cannot auto generate ID. Please try again or contact admin for supports`,
  EMSG_8011: `Cannot assign procedures to order. Please fill valid procedures.`,
  EMSG_8012: `Cannot assign device to order. Please fill a valid device.`,
  EMSG_8013: `Invalid patient ID. Please fill a valid patient ID or leave it blank.`,
  EMSG_8014: `Fail to receive`,
  EMSG_8015: `Institution mismatch. please choose the same Institution`,
  EMSG_8016: `Invalid order status. Please choose status is New/Cancel.`,
  EMSG_8017: `Invalid order status.`,
  EMSG_8018: `Please choose procedure`,
  EMSG_8019: `Cannot delete order with status is ARRIVED`,
  EMSG_9001: `Layout Report Name already been used`,
  EMSG_9002: `Not found layout ID`,
  EMSG_10000: `Approve all reports before create new`,
  EMSG_10001: `Not found report`,
  EMSG_10002: `Invalid report's actions flow`,
  EMSG_10003: `Another doctor is reading this report`,
  EMSG_10004: `Fail to cancel report`,
  EMSG_13001: `Device name has already been used`,
  EMSG_14001: `Fail to share study`,
  EMSG_14002: `Fail to update share study`,
  EMSG_14003: `Cannot delete expired share study`,
  EMSG_14004: `Limited study share on a month's`,
  EMSG_14005: `Invalid institution to share study`,
  EMSG_15001: `Filter Name has already been used`,
  EMSG_15002: `Not found filter`,
  EMSG_16001: `Fail to create rule CAD`,
  EMSG_16002: `Fail to update rule CAD`,
  EMSG_16003: `Fail to delete rule CAD`,
  EMSG_16004: `Can not find rule CAD`,
  EMSG_17001: `Can't update the request has been marked as either "reading" or "completed"`,
  EMSG_17002: `Can't delete the request has been marked as either "reading" or "completed"`,
  EMSG_17003: `Please choose group account`,
  EMSG_17004: `Please choose account`,
  EMSG_18001: `Can not delete all data. Please contact admin for supports.`,
  EMSG_19001: `Can not create or reset password. Please contact admin for supports.`,
  EMSG_19002: `Can not create or reset password. Please update phone number`,
  EMSG_19003: `Institution ID invalid. Please contact admin for supports`,
  EMSG_20001: `Body part name has already been used`,
  EMSG_21001: `Department code has already been used`,
  EMSG_21002: `Department name has already been used`,
  EMSG_25001: `Fail to create print job`,
  EMSG_29001: `Not found recorded annotation`,
  EMSG_29002: `Fail to update this recorded annotation`,
  EMSG_29003: `Fail to create this recorded annotation`,
  EMSG_29004: `Fail to get the recorded annotations`,
  EMSG_29005: `Wrong owner of this recorded annotation`,
  EMSG_29006: `Fail to delete recorded annotation`,
  EMSG_29007: `Not found valid study to perform`,
};
const inline_error_message = {
  IEM_0001: `Please fill value in this field`,
  IEM_2001: `Enter in the format: name@example.com`,
  IEM_2002: `At least 10 numbers and allow character +`,
  IEM_4000: `At least 8 characters long`,
  IEM_4001: `The password confirmation does not match`,
  IEM_4002: `Enter in the format: name@example.com`,
  IEM_4003: `At least 10 numbers and allow character +`,
  IEM_4004: `The password is incorrect`,
};
const confirmation_dialog = {
  CFD_2000: `Are you sure you want to delete institution?`,
  CFD_3000: `Are you sure you want to delete role?`,
  CFD_4000: `Are you sure you want to delete user?`,
  CFD_4001: `Are you sure you want to delete group account?`,
  CFD_5000: `Are you sure want to unmacth order?`,
  CFD_6000: `Are you sure you want to delete procedure group?`,
  CFD_6001: `Are you sure you want to delete procedure?`,
  CFD_7000: `Are you sure want to delete template report?`,
  CFD_8000: `Are you sure want to delete order?`,
  CFD_9000: `Are you sure want to delete layout report?`,
  CFD_10000: `This template will overwrite your current work. Do you want to continue?`,
  CFD_13000: `Are you sure want to delete device?`,
  CFD_14000: `Are you sure want to delete share study?`,
  CFD_15000: `Are you sure want to delete this filter?`,
  CFD_16000: `Are you sure want to delete this rule CAD?`,
  CFD_17000: `Are you sure want to delete this request?`,
  CFD_19000: `Are you sure want to delete patient?`,
  CFD_19001: `Are you sure want to reset password?`,
  CFD_20000: `Are you sure you want to delete body part?`,
  CFD_21000: `Are you sure you want to delete department?`,
};
const success_message = {
  SCD_2000: `The institution has been created`,
  SCD_2001: `The institution has been updated`,
  SCD_2002: `The institution has been deleted`,
  SCD_3000: `The role has been created`,
  SCD_3001: `The role has been updated`,
  SCD_3002: `The role has been deleted`,
  SCD_4000: `The account has been created`,
  SCD_4001: `The account has been updated`,
  SCD_4002: `The account has been deleted`,
  SCD_4003: `Group account has been created`,
  SCD_4004: `Group account has been updated`,
  SCD_4005: `Group account has been deleted`,
  SCD_5000: `All orders have been matched`,
  SCD_5001: `All orders have been unmatched`,
  SCD_6000: `The procedure group has been created`,
  SCD_6001: `The procedure group has been updated`,
  SCD_6002: `The procedure group has been deleted`,
  SCD_6003: `The procedure has been created`,
  SCD_6004: `The procedure has been updated`,
  SCD_6005: `The procedure has been deleted`,
  SCD_7000: `The template report has been created`,
  SCD_7001: `The template report has been updated`,
  SCD_7002: `The template report has been deleted`,
  SCD_8000: `The order has been created`,
  SCD_8001: `The order has been updated`,
  SCD_8002: `The order has been deleted`,
  SCD_8003: `You can use this Patient ID`,
  SCD_8004: `The order has been received`,
  SCD_9000: `The layout report has been created`,
  SCD_9001: `The layout report has been updated`,
  SCD_9002: `The layout report has been deleted`,
  SCD_10000: `The report has been created`,
  SCD_10001: `The report has been updated`,
  SCD_10002: `The report has been deleted`,
  SCD_13000: `The device has been created`,
  SCD_13001: `The device has been updated`,
  SCD_13002: `The device has been deleted`,
  SCD_14001: `This study has been shared`,
  SCD_14002: `This study share has been updated`,
  SCD_14003: `This study share has been deleted`,
  SCD_15001: `The filter has been created`,
  SCD_15002: `The filter has been updated`,
  SCD_15003: `The filter has been deleted`,
  SCD_16001: `The rule CAD has been created`,
  SCD_16002: `The rule CAD has been updated`,
  SCD_16003: `The rule CAD has been deleted`,
  SCD_17001: `This request has been assigned`,
  SCD_17002: `This request has been updated`,
  SCD_17003: `This request has been deleted`,
  SCD_18001: `Key image has been created`,
  SCD_18002: `This data has been deleted`,
  SCD_19001: `The patient account has been created`,
  SCD_19002: `The account has been updated`,
  SCD_19003: `The account has been deleted`,
  SCD_20000: `The body part has been created`,
  SCD_20001: `The body part has been updated`,
  SCD_20002: `The body part has been deleted`,
  SCD_21000: `The department has been created`,
  SCD_21001: `The department has been updated`,
  SCD_21002: `The department has been deleted`,
  SCD_25001: `The print job has been created`,
};

export const MESSAGE = Object.freeze({
  ERROR: error_message,
  INLINE: inline_error_message,
  DIALOG: confirmation_dialog,
  SUCCESS: success_message,
});
